'use client';

// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-react/build/generate-icons

import { IconArrowsRepeat, iconArrowsRepeatTag } from '@ni/nimble-components/dist/esm/icons/arrows-repeat';
import { wrap } from '../../utilities/react-wrapper';

export type { IconArrowsRepeat };
export { iconArrowsRepeatTag };
export const NimbleIconArrowsRepeat = wrap(IconArrowsRepeat);